var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8335 4.83333L13.1107 14.9521C13.0484 15.8243 12.3227 16.5 11.4483 16.5H4.55203C3.67763 16.5 2.95189 15.8243 2.8896 14.9521L2.16683 4.83333H5.50016V2.33333C5.50016 1.8731 5.87326 1.5 6.3335 1.5H9.66683C10.1271 1.5 10.5002 1.8731 10.5002 2.33333V4.83333H13.8335Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8335 4.83333L13.1107 14.9521C13.0484 15.8243 12.3227 16.5 11.4483 16.5H4.55203C3.67763 16.5 2.9519 15.8243 2.8896 14.9521L2.16683 4.83333M6.3335 8.16667V13.1667M9.66683 8.16667V13.1667M10.5002 4.83333V2.33333C10.5002 1.8731 10.1271 1.5 9.66683 1.5H6.3335C5.87326 1.5 5.50016 1.8731 5.50016 2.33333V4.83333M1.3335 4.83333H14.6668",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.4801bb3b7a3f73a149834ae8828be2eb.svg";
export { ForwardRef as ReactComponent };